import { render } from "./ReviewDependent.vue?vue&type=template&id=4e436f72&ts=true"
import script from "./ReviewDependent.vue?vue&type=script&lang=ts"
export * from "./ReviewDependent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__